const $doc = $(document);
const $notify = $('.js-notify');

$notify.find('form').on('submit', function(e) {
  e.preventDefault();
  const $this = $(this);
  const action = $this.attr('action');
  const $notify = $this.closest('.js-notify');
  const $product = $this.closest('.js-product');
  const variantId = $product.find('.js-select-global option:selected').val();

  $this.find('input[name="variant"]').val(variantId);

  $.ajax({
    url: action,
    method: 'POST',
    data: $this.serialize(),
    success: function(result) {
      if (result.success) {
        $notify.addClass('notify--success');
      };
    },
    error: function(error) {
      
    }
  });
});



// WEBPACK FOOTER //
// ../assets/js/notify.js